__webpack_require__.p = "https://statics.quantitativecapital10.com/admin/1.31.0/";